/**
 * Model Status
 * Standard status codes for model objects.
 * Used to indicate if the object is usable.
 * Not all models support all the status codes defined here.
 */
export enum ModelStatus {
  PENDING = 0,
  ACTIVE = 100,
  INACTIVE = -100,
  DELETED = -1000,
}
